import { render, staticRenderFns } from "./IntegrationItem.vue?vue&type=template&id=ae7d4734"
import script from "./IntegrationItem.vue?vue&type=script&lang=js"
export * from "./IntegrationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae7d4734')) {
      api.createRecord('ae7d4734', component.options)
    } else {
      api.reload('ae7d4734', component.options)
    }
    module.hot.accept("./IntegrationItem.vue?vue&type=template&id=ae7d4734", function () {
      api.rerender('ae7d4734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/IntegrationItem.vue"
export default component.exports